import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { TaskCard } from './card/card';
import { Tasks } from 'common/src/utils/types';

interface SortableTaskProps {
  id: string;
  cardTitle: string;
  cardCategory: string;
  onClick: () => void;
  assignedUserInitials: string;
  assignedUserName: string;
  price: number;
  date: string;
  onEdit: () => void;
  name: string;
  last_name: string;
  phone_number: string;
  onDelete: () => void;
  onAddComment: (task: Tasks) => void;
  task: Tasks;
}

const SortableTask: React.FC<SortableTaskProps> = ({
  id,
  cardTitle,
  cardCategory,
  onClick,
  assignedUserInitials,
  assignedUserName,
  price,
  date,
  onEdit,
  name,
  last_name,
  phone_number,
  onDelete,
  onAddComment,
  task,
}) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <TaskCard
        cardTitle={cardTitle}
        cardCategory={cardCategory}
        onClick={onClick}
        assignedUserInitials={assignedUserInitials}
        assignedUserName={assignedUserName}
        price={price}
        date={date}
        onEdit={onEdit}
        name={name}
        last_name={last_name}
        onDelete={onDelete}
        phone_number={phone_number}
        onAddComment={() => onAddComment(task)}
        task={task}
      />
    </div>
  );
};

export default SortableTask;
